import { useProjectsList } from "modules/projects/hooks/useProjectsList"
import { useMemo } from "react"
import { toSlug } from "../../utils"

/**
 * Returns an object of project counts by market sector slug.
 * @example
 * const { data: projectCountBySectorSlug } = useProjectCountBySectorSlug()
 *
 * // projectCountBySectorSlug = {
 * //   "gaming": 200,
 * //   "lending": 100,
 * //   ...
 * // }
 */

export const useProjectCountBySectorSlug = () => {
  const { data: projects = [] } = useProjectsList()

  return useMemo(() => {
    return projects?.reduce(
      (acc, project) => {
        project.market_sectors.forEach((sectorId) => {
          const slug = toSlug(sectorId)
          acc[slug] = (acc[slug] || 0) + 1
        })
        return acc
      },
      {} as Record<string, number>
    )
  }, [projects])
}
